export const BRAND_ID = 'DB20FA2B-DAD8-489D-97C3-F03AB89F0D53';

// Accent (003) still chats via CommunicationHub/Twilio; all other brands use the omnichannel 1-on-1 chat.
export const ACCENT_BRAND_ID = '4B0C292F-5688-4FAA-9C7B-4431B9F0BE54';

